import {
  Box,
  List,
  ListItemButton,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";

import { formatDate } from "../../../../utils";
import { thinScrollbarSx } from "./constants";
import { ChatSummary } from "./types";

type ChatSidebarProps = {
  chats: ChatSummary[];
  activeChatId: string | null;
  onSelectChat: (chatId: string) => void;
  disabled?: boolean;
};

const ChatSidebar = ({
  chats,
  activeChatId,
  onSelectChat,
}: ChatSidebarProps) => {
  const theme = useTheme();

  return (
    <Stack
      sx={{
        width: 240,
        flexShrink: 0,
        height: "100%",
        borderRight: "1px solid",
        borderColor: "divider",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        sx={{ px: 1.5, py: 1.25, flexShrink: 0 }}
      >
        <Typography variant="subtitle2" fontWeight={600}>
          Conversas
        </Typography>
      </Stack>

      <Box
        sx={{
          width: "75%",
          height: "1px",
          alignSelf: "center",
          flexShrink: 0,
          bgcolor: "primary.main",
          boxShadow: `0 0 10px ${alpha(
            theme.palette.primary.main,
            theme.palette.mode === "light" ? 0.45 : 0.55,
          )}`,
          mb: 0.5,
        }}
      />

      <List
        sx={{
          flex: 1,
          minHeight: 0,
          overflowY: "auto",
          py: 0,
          ...thinScrollbarSx,
        }}
      >
        {chats.map((chat) => (
          <ListItemButton
            key={chat.id}
            selected={chat.id === activeChatId}
            onClick={() => onSelectChat(chat.id)}
            sx={{
              px: 1.5,
              py: 1,
              "&.Mui-selected": {
                bgcolor: alpha(theme.palette.primary.main, 0.12),
              },
            }}
          >
            <ListItemText
              primary={chat.title}
              secondary={formatDate(chat.updatedAt, "D/M/Y H:i")}
              primaryTypographyProps={{ variant: "body2", noWrap: true }}
              secondaryTypographyProps={{ variant: "caption" }}
            />
          </ListItemButton>
        ))}

        {chats.length === 0 && (
          <Box sx={{ px: 1.5, py: 2 }}>
            <Typography variant="caption" color="text.secondary">
              Nenhuma conversa ainda.
            </Typography>
          </Box>
        )}
      </List>
    </Stack>
  );
};

export default ChatSidebar;
